import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import configurazioni from '@/services/configurazioniService'
Vue.use(Vuex)


export default {
  namespaced: true,
  state: {
    magazziniMultipli: null, 
    magazzini: [],
    magazzino: null
  },
  getters: {
    magazziniMultipli: state => state.magazziniMultipli,
    magazzino: state => state.magazzino,
    codiceMagazzino: state => _.get(state.magazzino, 'codice', ''),
    magazzini: state => state.magazzini
  },
  mutations: {
    SET_MAGAZZINI_MULTIPLI (state, usaMultipli) {
      state.magazziniMultipli = usaMultipli
    },
    SET_MAGAZZINI (state, magazzini) {
      state.magazzini = magazzini
    },
    SET_MAGAZZINO (state, payload) {
      state.magazzino = payload
    },
    CLEAR_MAGAZZINO (state) {
      state.magazzino = null
    }
  },
  actions: {
    async usaMagazziniMultipli({ commit, state }) {
      if (state.magazziniMultipli !== null) {
        return state.magazziniMultipli
      }
      const impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      const usaMultipli =  _.get(impostazioni, 'magazzino.magazziniMultipli', false)
      commit('SET_MAGAZZINI_MULTIPLI', usaMultipli)
      return usaMultipli
    },
    async getElencoMagazzini({ commit, state }, refresh) {
      if (state.magazzini.length > 0 && !refresh) {
        return state.magazzini
      }
      const magazzini = await configurazioni.getConfigurazione('magazzino_magazzini', 'magazzini')
      commit('SET_MAGAZZINI', magazzini)
      return magazzini
    },
    async getMagazzino({dispatch, commit, state}) {
      if (state.magazzino) {
        return state.magazzino
      } else {
        if (state.magazzini.length === 0) {
          await dispatch('getElencoMagazzini')
        }
        if (state.magazzini.length > 0) {
          const magazzino = state.magazzini.find(x => x.default) || state.magazzini[0]
          commit('SET_MAGAZZINO', magazzino)
          return magazzino
        }
        return null
      }
    }
  }
}
